// extracted by mini-css-extract-plugin
export default {"section":"GamesByGeo_section__R8Ny3","header":"GamesByGeo_header__QRDXc","titleWrapper":"GamesByGeo_titleWrapper__tVpoo","content":"GamesByGeo_content__+nRoB"};